export { DeleteUser as default } from './delete-user';
